import React, { memo } from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface VoiceDebugPanelProps {
  isListening: boolean;
  transcript: string;
  voiceTranscripts: string[];
  voiceStatus: string;
}

// Use React.memo to prevent unnecessary re-renders
const VoiceDebugPanel = memo(function VoiceDebugPanel({
  isListening,
  transcript,
  voiceTranscripts,
  voiceStatus,
}: VoiceDebugPanelProps) {
  // Memoize the transcript list to prevent unnecessary re-renders
  const transcriptList = React.useMemo(() => {
    return voiceTranscripts.map((t, i) => <li key={i}>{t}</li>);
  }, [voiceTranscripts]);

  return (
    <Card className="mt-4 border-dashed border-yellow-500">
      <CardHeader className="bg-yellow-50 dark:bg-yellow-900/10">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">
            Voice Recognition Debug
          </CardTitle>
          <Badge variant={isListening ? "default" : "secondary"}>
            {voiceStatus}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="text-xs">
        <div className="mb-2">
          <strong>Current:</strong> {transcript || "(none)"}
        </div>
        <div>
          <strong>Recent:</strong>
          <ul className="list-disc pl-4">{transcriptList}</ul>
        </div>
      </CardContent>
    </Card>
  );
});

export default VoiceDebugPanel;
